import httpClient from "@/_shared/http-client";
import { date } from "@/_shared/utils";

const configs = {
  import: {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },
};

const generateDocument = async(data) => {
  const { entity, ids, operation } = data;
  const body = { entity, ids };
  const slug = `/data/document/${operation}`;
  const url = new URL(slug, process.env.BACKEND_URL);
  await httpClient.post(url, body).then((results) => {
    const fileName = results.data.file_name;
    const link = document.createElement('a');
    link.href = `${process.env.BACKEND_URL}/static/generated`
      + `-docs/${fileName}`;
    link.click();
  });
};

const importRecords = async(file, entity) => {
  const body = new FormData()
  body.append('importing_file', file);

  const slug = '/data/parser/import';
  const url = new URL(slug, process.env.BACKEND_URL);
  url.searchParams.set('entity', entity);
  url.searchParams.set('datetime', date.getIsoString());
  const response = await httpClient.post(url, body, configs.import)
    .catch((err) => {
      const { response } = err;
      throw new Error(response.data.message)
    });
  return response;
};

export const dataService = {
  generateDocument,
  importRecords,
};



// WEBPACK FOOTER //
// ./src/_shared/api-services/dataService.js